import { DEFAULT_PAGE_SIZE } from 'dashboard/lib/constants/pagination';
import { TableState } from 'dashboard/lib/interfaces/TableState';
import {
  GraphQueryTemplate,
  GraphQueryTemplateStatus,
} from 'dashboard/models/graph-query-template';
import {
  Filters,
  GraphQueryTemplateAction,
  GraphQueryTemplatesActionType,
} from 'dashboard/redux/actions/graph-query-templates';

export interface GraphQueryTemplatesState extends TableState {
  graphQueryTemplates: GraphQueryTemplate[];
  // Overriding type declared in TableState
  filters: Filters;
}

export const initialGraphQueryTemplateState: GraphQueryTemplatesState = {
  graphQueryTemplates: [],
  filters: {
    status: [GraphQueryTemplateStatus.Active],
  },
  sortParams: {
    sort: 'name',
    shouldSortDescending: false,
  },
  paginationParams: {
    'current-page': 1,
    'total-count': 100,
    'total-pages': 10,
  },
  pageSize: DEFAULT_PAGE_SIZE,
  currentPage: 1,
};

export default (
  state: GraphQueryTemplatesState = initialGraphQueryTemplateState,
  action: GraphQueryTemplateAction,
) => {
  switch (action.type) {
    case GraphQueryTemplatesActionType.SetCurrentPage: {
      return {
        ...state,
        currentPage: action.payload.currentPage,
      };
    }
    case GraphQueryTemplatesActionType.SetFilters: {
      return {
        ...state,
        filters: action.payload.filters,
      };
    }
    case GraphQueryTemplatesActionType.SetGraphQueryTemplates: {
      return {
        ...state,
        graphQueryTemplates: action.payload.graphQueryTemplates,
      };
    }
    case GraphQueryTemplatesActionType.SetPageSize: {
      return {
        ...state,
        pageSize: action.payload.pageSize,
      };
    }
    case GraphQueryTemplatesActionType.SetSortParams: {
      return {
        ...state,
        sortParams: {
          ...state.sortParams,
          ...action.payload.sortParams,
        },
      };
    }
    default:
      return state;
  }
};
